import React from "react";
import Dropdown from "react-multilevel-dropdown";
import { useNavigateUrl } from "managers/utilManager";

const NavbarItem = ({ data }) => {
  const navigateUrl = useNavigateUrl();

  const handleClick = (e, item) => {
    e?.preventDefault?.();
    navigateUrl(item?.url, { externalTarget: "_blank" });
    console.log(item?.url);
  };

  if (data && data.length > 0) {
    return data.map((item) =>
      !item.children ? (
        <Dropdown.Item
          key={item.id}
          data-key={`${item?.url}`}
          onClick={(e) => handleClick(e, item)}
          className="dropdown-brand-color"
        >
          {item.title}
        </Dropdown.Item>
      ) : (
        <Dropdown.Item key={item.id} className="dropdown-brand-color">
          {item.title}
          <Dropdown.Submenu
            key={`submenu-${item.id}`}
            position="right"
            className="submenu-right-98 submenu-mobile"
          >
            <NavbarItem data={item.children} />
          </Dropdown.Submenu>
        </Dropdown.Item>
      )
    );
  }

  return "";
};

export default NavbarItem;
